
/**
 * 인증 제공자
 */
export type UpdateUser200Provider = typeof UpdateUser200Provider[keyof typeof UpdateUser200Provider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUser200Provider = {
  LOCAL: 'LOCAL',
  GOOGLE: 'GOOGLE',
  GITHUB: 'GITHUB',
  FACEBOOK: 'FACEBOOK',
} as const;
